import React from "react";
import {Link} from "react-router-dom";
import "./Breadcrumb.css";


export type BreadcrumbItem = {
    label: string;
    to?: string;
}

export interface BreadcrumbProps {
    items: BreadcrumbItem[];
}


const Breadcrumb: React.FC<BreadcrumbProps> = ({items}) => {
    return (
        <nav className="breadcrumb" aria-label="Breadcrumb">
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    <div key={index} className="breadcrumb-item">
                        {!isLast ? (
                            <Link to={item.to!} className="breadcrumb-link">
                                {item.label}
                            </Link>
                        ) : (
                            <span className="breadcrumb-current" aria-current="page">
                {item.label}
              </span>
                        )}
                        {!isLast && <span className="breadcrumb-separator">/</span>}
                    </div>
                );
            })}
        </nav>
    );
};

export default Breadcrumb;
